// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Coordinators_coordinators__EOuvv {
  display: flex;
  flex-direction: column;
}

.Coordinators_coordinator__ulRak {
  padding: 6px 0;
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #E0E7EB;
  align-items: center;
}
.Coordinators_coordinator__ulRak:last-child {
  border: none;
}
.Coordinators_coordinator__avatar__zwZNW {
  width: 24px !important;
  height: 24px !important;
}
.Coordinators_coordinator__status__AkTrV svg {
  fill: none;
}
.Coordinators_coordinator__info__3Hcb7 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  line-height: 114%;
  max-width: calc(100% - 24px - 8px - 8px - 16px - 8px - 20px);
}
.Coordinators_coordinator__name__aPLmt {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Coordinators_coordinator__disabled__Pdef- {
  color: #668899;
}
.Coordinators_coordinator__ulRak .Coordinators_status-container__5WfPQ {
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}
.Coordinators_coordinator__status__AkTrV {
  padding: 2px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
}
.Coordinators_coordinator__ulRak:hover .Coordinators_tooltip_icon-container__WHtFZ {
  opacity: 1;
}

.Coordinators_status--resolve__yTPTl {
  background: #F7FCF9;
}
.Coordinators_status--resolve__yTPTl svg {
  fill: #41C061;
}
.Coordinators_status--reject__KvPR8 {
  background: #FDE8E7;
}
.Coordinators_status--progress__jP5VS {
  background: #E8F3FC;
}
.Coordinators_status--wait__xr6WR {
  background: #EFF3F5;
}

.Coordinators_tooltip_icon-container__WHtFZ {
  opacity: 0;
  align-items: center;
}
.Coordinators_tooltip_icon-container__WHtFZ svg {
  fill: #668899;
}
.Coordinators_tooltip_icon-container__WHtFZ svg path {
  stroke: white;
}

.Coordinators_tooltip_position__-j\\+XS {
  background: #1D222E !important;
  font-size: 12px !important;
  z-index: 101 !important;
  overflow: initial !important;
  border-radius: 8px !important;
  padding: 6px !important;
}
.Coordinators_tooltip_position__-j\\+XS .react-tooltip-arrow {
  display: block !important;
}

.Coordinators_tooltip_content__oAKiZ {
  display: flex;
}
.Coordinators_tooltip_content__oAKiZ .Coordinators_tooltip_left-info__i-fiz, .Coordinators_tooltip_content__oAKiZ .Coordinators_tooltip_right-info__YSnuh {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 13.2px;
}
.Coordinators_tooltip_content__oAKiZ .Coordinators_tooltip_right-info__YSnuh {
  font-weight: 400;
  margin-left: 20px;
  align-items: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/Coordinators/Coordinators.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,sBAAA;EACA,uBAAA;AAAJ;AAII;EACE,UAAA;AAFN;AAME;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,4DAAA;AAJJ;AAOE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AALJ;AAQE;EACE,cAAA;AANJ;AAaE;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAXJ;AAcE;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAiBI;EACE,UAAA;AAfN;;AAqBE;EACE,mBAAA;AAlBJ;AAoBI;EACE,aAAA;AAlBN;AAqBE;EACE,mBAAA;AAnBJ;AAqBE;EACE,mBAAA;AAnBJ;AAqBE;EACE,mBAAA;AAnBJ;;AAuBA;EACE,UAAA;EACA,mBAAA;AApBF;AAsBE;EACE,aAAA;AApBJ;AAsBI;EACE,aAAA;AApBN;;AAyBA;EACE,8BAAA;EACA,0BAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;AAtBF;AAyBI;EACE,yBAAA;AAvBN;;AA4BA;EACE,aAAA;AAzBF;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AA1BJ","sourcesContent":[".coordinators {\n  display: flex;\n  flex-direction: column;\n}\n\n.coordinator {\n  padding: 6px 0;\n  display: flex;\n  gap: 8px;\n  border-bottom: 1px solid #E0E7EB;\n  align-items: center;\n\n  &:last-child {\n    border: none;\n  }\n\n  &__avatar {\n    width: 24px!important;\n    height: 24px!important;\n  }\n\n  &__status {\n    svg {\n      fill: none;\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    font-size: 12px;\n    line-height: 114%;\n    max-width: calc(100% - 24px - 8px - 8px - 16px - 8px - 20px);\n  }\n\n  &__name {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__disabled {\n    color: #668899;\n  }\n\n  // &__name {\n  //   margin-top: 5px;\n  // }\n\n  .status-container {\n    margin-left: auto;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n\n  &__status {\n    // margin-left: auto;\n    padding: 2px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 35px;\n  }\n\n  &:hover {\n    .tooltip_icon-container {\n      opacity: 1;\n    }\n  }\n}\n\n.status {\n  &--resolve {\n    background: #F7FCF9;\n\n    svg {\n      fill: #41C061;\n    }\n  }\n  &--reject {\n    background: #FDE8E7;\n  }\n  &--progress {\n    background: #E8F3FC;\n  }\n  &--wait {\n    background: #EFF3F5;\n  }\n}\n\n.tooltip_icon-container {\n  opacity: 0;\n  align-items: center;\n\n  svg {\n    fill: #668899;\n\n    path {\n      stroke: white;\n    }\n  }\n}\n\n.tooltip_position {\n  background: #1D222E !important;\n  font-size: 12px!important;\n  z-index: 101 !important;\n  overflow: initial !important;\n  border-radius: 8px!important;\n  padding: 6px !important;\n\n  :global {\n    .react-tooltip-arrow {\n      display: block!important;\n    }\n  }\n}\n\n.tooltip_content {\n  display: flex;\n\n  .tooltip_left-info, .tooltip_right-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 13.2px;\n  }\n\n  .tooltip_right-info {\n    font-weight: 400;\n    margin-left: 20px;\n    align-items: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coordinators": `Coordinators_coordinators__EOuvv`,
	"coordinator": `Coordinators_coordinator__ulRak`,
	"coordinator__avatar": `Coordinators_coordinator__avatar__zwZNW`,
	"coordinator__status": `Coordinators_coordinator__status__AkTrV`,
	"coordinator__info": `Coordinators_coordinator__info__3Hcb7`,
	"coordinator__name": `Coordinators_coordinator__name__aPLmt`,
	"coordinator__disabled": `Coordinators_coordinator__disabled__Pdef-`,
	"status-container": `Coordinators_status-container__5WfPQ`,
	"tooltip_icon-container": `Coordinators_tooltip_icon-container__WHtFZ`,
	"status--resolve": `Coordinators_status--resolve__yTPTl`,
	"status--reject": `Coordinators_status--reject__KvPR8`,
	"status--progress": `Coordinators_status--progress__jP5VS`,
	"status--wait": `Coordinators_status--wait__xr6WR`,
	"tooltip_position": `Coordinators_tooltip_position__-j+XS`,
	"tooltip_content": `Coordinators_tooltip_content__oAKiZ`,
	"tooltip_left-info": `Coordinators_tooltip_left-info__i-fiz`,
	"tooltip_right-info": `Coordinators_tooltip_right-info__YSnuh`
};
export default ___CSS_LOADER_EXPORT___;
